/**
 * @generated SignedSource<<79c1e4f90c18039d1d4a0ecc5d74947a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_sku$data = {
  readonly holidayShippingEstimations?: {
    readonly displayMessage: string | null;
    readonly termsAndConditions: string | null;
    readonly validHolidayShippingDays: ReadonlyArray<{
      readonly estimatedDeliveryDay: string | null;
      readonly shipmentQuoteId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PdpSharedShippingHolidayDelivery_sku";
};
export type PdpSharedShippingHolidayDelivery_sku$key = {
  readonly " $data"?: PdpSharedShippingHolidayDelivery_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "timezoneOffset"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingHolidayDelivery_sku",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "timezoneOffset",
              "variableName": "timezoneOffset"
            }
          ],
          "concreteType": "HolidayShippingEstimationsType",
          "kind": "LinkedField",
          "name": "holidayShippingEstimations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "termsAndConditions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ValidHolidayShippingDays",
              "kind": "LinkedField",
              "name": "validHolidayShippingDays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shipmentQuoteId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimatedDeliveryDay",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "89e44a857afc96626109bd6b56ffc655";

export default node;
